// Import the functions you need from the SDKs you need
import { initializeApp } from "firebase/app";
import { getAnalytics } from "firebase/analytics";
import { getAuth } from "firebase/auth";
// TODO: Add SDKs for Firebase products that you want to use
// https://firebase.google.com/docs/web/setup#available-libraries

// Your web app's Firebase configuration
// For Firebase JS SDK v7.20.0 and later, measurementId is optional
const firebaseConfig = {
  apiKey: "AIzaSyDFyiHd3kZCTjgOZqWpt4iKT_QUiRkrWPg",
  authDomain: "youthstoday-143d4.firebaseapp.com",
  projectId: "youthstoday-143d4",
  storageBucket: "youthstoday-143d4.appspot.com",
  messagingSenderId: "715357469640",
  appId: "1:715357469640:web:eb489220f513ad7e769efd",
  measurementId: "G-5ZZJ3J07G0",
};

// Initialize Firebase
const app = initializeApp(firebaseConfig);

// Exports to use throughout project
export const analytics = getAnalytics(app);
export const firebaseAuth = getAuth(app);
